/**
 * LES ROUTES DU MODULE DES ALARMES V2 (LOT F1 : LA LISTE ; LOT F4 : LE CATALOGUE ;
 * LOT F5 : L'OPTION AVANCÉ).
 * ============================================================================
 *
 * Aucune ne reprend un chemin ni un nom de la V1 (`alarme`, `PageBuildingAlarm`,
 * `PageSourceAlarm`, `PageUserAlarm`). Chaque route connectée enregistre les
 * messages du module puis attend la porte (`utils/porte.ts`).
 */
import type { RouteRecordRaw } from "vue-router"
import PageSurveillances from "./pages/PageSurveillances.vue"
import PageSurveillanceCatalogue from "./pages/PageSurveillanceCatalogue.vue"
import PageSurveillanceOption from "./pages/PageSurveillanceOption.vue"
import { enregistrerMessagesAlarmesV2 } from "./i18n/enregistrer"
import { porteAlarmesV2 } from "./utils/porte"
import {
    CHEMIN_CATALOGUE,
    CHEMIN_OPTION_AVANCE,
    CHEMIN_SURVEILLANCES,
} from "./utils/menu"

/** Enregistre les messages, puis juge l'entrée. */
async function entrer() {
    enregistrerMessagesAlarmesV2()
    return porteAlarmesV2()
}

export const routes = [
    {
        path: CHEMIN_SURVEILLANCES,
        name: "PageSurveillances",
        component: PageSurveillances,
        meta: {
            requiresAuth: true,
            layout: "header",
            documentTitle: "Surveillance",
        },
        beforeEnter: entrer,
    },
    {
        // Query facultative `objet_type` et `_id_objet` : le catalogue filtré
        // sur ce que cet équipement mesure.
        path: CHEMIN_CATALOGUE,
        name: "PageSurveillanceCatalogue",
        component: PageSurveillanceCatalogue,
        meta: {
            requiresAuth: true,
            layout: "header",
            documentTitle: "Catalogue des types d'alarme",
        },
        beforeEnter: entrer,
    },
    {
        path: CHEMIN_OPTION_AVANCE,
        name: "PageSurveillanceOption",
        component: PageSurveillanceOption,
        meta: {
            requiresAuth: true,
            layout: "header",
            documentTitle: "Option Avancé et SMS",
        },
        beforeEnter: entrer,
    },
] as RouteRecordRaw[]
